import { Button, Checkbox } from 'antd';
import { ReactNode } from 'react';

import * as S from './styles';

export { FloatingSpace as SelectionBarSpace } from './styles';

interface Props {
  label: string;
  selectedCount: number;
  totalCount: number;
  isToggleAllDisabled?: boolean;
  onToggleAll: () => void;
  onClear: () => void;
  children: ReactNode;
}

const describeSelection = (count: number): string =>
  count === 1
    ? '1 selecionado'
    : `${count.toLocaleString('pt-BR')} selecionados`;

export default function SelectionBar({
  label,
  selectedCount,
  totalCount,
  isToggleAllDisabled = false,
  onToggleAll,
  onClear,
  children,
}: Props) {
  const isAllSelected = totalCount > 0 && selectedCount === totalCount;

  return (
    <>
      <S.Bar aria-label={label}>
        <Checkbox
          checked={isAllSelected}
          indeterminate={selectedCount > 0 && !isAllSelected}
          disabled={totalCount === 0 || isToggleAllDisabled}
          onChange={onToggleAll}
        >
          Selecionar todos
        </Checkbox>
      </S.Bar>

      {selectedCount > 0 && (
        <S.Floating aria-label="Ações da seleção">
          <S.Count>{describeSelection(selectedCount)}</S.Count>
          <Button type="link" onClick={onClear}>
            Limpar
          </Button>
          <S.Action>{children}</S.Action>
        </S.Floating>
      )}
    </>
  );
}
